import { gql } from '@apollo/client';

import {
  CustomIntegrationFragment,
  OauthIntegrationFragment,
  ShareFileIntegrationFragment,
} from './integration.fragment';

export * from './integration.query.generated';

export const INTEGRATION = gql`
  query integration($integrationId: ID!) {
    integration(integrationId: $integrationId) {
      ... on OauthIntegration {
        ...OauthIntegrationFragment
      }
      ... on CustomIntegration {
        ...CustomIntegrationFragment
      }
      ... on ShareFileIntegration {
        ...ShareFileIntegrationFragment
      }
    }
  }
  ${OauthIntegrationFragment}
  ${CustomIntegrationFragment}
  ${ShareFileIntegrationFragment}
`;
